export default "/images/e46e7ce2e4d00d3e243f414b58f542a9.avif";